#### Self-service credential management

We’ve added the ability to provision and rotate SEEK API client credentials to the Developer Dashboard.
Previously, you’d have to contact SEEK to manage your credentials.

See our revised [integration process] to learn more,
and jump to the [Developer Dashboard credentials page] to get started.

[Developer Dashboard credentials page]: /manage/credentials
[integration process]: /introduction#integration-process
